import client from '../../client';
import {
  GET_BILLING_DATA,
  GET_BILLING_DATA_SUCCESS,
  GET_BILLING_DATA_FAIL
} from '../constants/billing';

export const getBillingData = (params, graphId) => dispatch => {
  dispatch({
    type: GET_BILLING_DATA,
    graphId
  });

  client
    .get('/billings/graph', { params })
    .then(res => {
      dispatch({
        type: GET_BILLING_DATA_SUCCESS,
        data: res.data,
        graphId
      });
    })
    .catch(error => {
      dispatch({
        type: GET_BILLING_DATA_FAIL,
        error,
        graphId
      })
    });
}



// WEBPACK FOOTER //
// ./src/redux/actions/billing.js